import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { mask } from 'vue-input-mask';

import './styles/main.css';

import App from './App.vue';
import AxiosAdapter from './infra/http/AxiosAdapter';
import router from './router';

import { useAuthStore } from './stores/AuthStore';

import AuthService from './services/AuthService';
import RoomService from './services/RoomServices';
import ParticipantService from './services/ParticipantService';

const app = createApp(App);

const baseUrl = process.env.VUE_APP_BASE_URL;
const httpClient = new AxiosAdapter(router);

const authService = new AuthService(httpClient, baseUrl);
const roomService = new RoomService(httpClient, baseUrl);
const participantService = new ParticipantService(httpClient, baseUrl);

const pinia = createPinia();

pinia.use(({ store }) => {
  (store.router = router), (store.authService = authService);
});

app.use(router);
app.use(pinia);
app.provide('authService', authService);
app.provide('roomService', roomService);
app.provide('participantService', participantService);
app.directive('mask', mask);

useAuthStore().init();
app.mount('#app');
